import { Route, Routes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import BackendSignIn from './pages/backend-sign-in/backend-sign-in';
import ResetPassword from './pages/reset-password/reset-password';
import ConfirmEmail from './pages/confirm-email/confirm-email';
import SignOut from './pages/sign-out/sign-out';
import ErrorPage from './pages/error/error-page';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signin/backend" element={<BackendSignIn />} />
        <Route path="/user/resetPassword" element={<ResetPassword />} />
        <Route path="/user/confirmEmail" element={<ConfirmEmail />} />
        <Route path="/signout" element={<SignOut />} />
        <Route path="/error" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;